import { createContext, useCallback, useState, ReactNode } from 'react'

interface MobileMenuContextType {
  openMenus: Map<string, () => void>
  openMenu: (id: string, closeFn: () => void) => void
  closeMenu: (id: string) => void
  closeAllMenus: () => void
}

const MobileMenuContext = createContext<MobileMenuContextType | undefined>(undefined)

interface MobileMenuProviderProps {
  children: ReactNode
}

export function MobileMenuProvider({ children }: MobileMenuProviderProps) {
  const [openMenus, setOpenMenus] = useState<Map<string, () => void>>(new Map())

  const openMenu = useCallback((id: string, closeFn: () => void) => {
    setOpenMenus((prev) => {
      prev.forEach((close, menuId) => {
        if (menuId !== id) {
          close()
        }
      })
      // Return a new map with only this menu
      return new Map([[id, closeFn]])
    })
  }, [])

  const closeMenu = useCallback((id: string) => {
    setOpenMenus((prev) => {
      const newMap = new Map(prev)
      newMap.delete(id)
      return newMap
    })
  }, [])

  const closeAllMenus = useCallback(() => {
    setOpenMenus((prev) => {
      // Close all menus by calling their close functions
      prev.forEach((close) => close())
      return new Map()
    })
  }, [])

  return (
    <MobileMenuContext.Provider
      value={{
        openMenus,
        openMenu,
        closeMenu,
        closeAllMenus,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  )
}

export { MobileMenuContext }
